import React from "react"
import { Route, Routes, useParams } from "react-router-dom"
import DinoEntryPage from "./DinoEntryPage"
import { Intro } from "./Intro"
import QuestionnairePage from "./QuestionnairePage"
import { DinoContextProvider } from "./components/DinoContext"
import Error404 from "../Error404"
import FiveLLResult from "./result/FiveLLResult"
import FMatQuadResult from "./result/FMatQuadResult"
import { useLanguageContext } from "../../components/context/LanguageContext"
import FMatHmiResult from "./result/FMatHmiResult"
import FMatTsiResult from "./result/FMatTsiResult"
import { FiveLLQuadResult } from "./result/FiveLLQuadResult"
import FMatBsi360Result from "./result/FMatBsi360Result"
import { ResultReportPage } from "./report/ResultReportPage"
import FMatLbiFastScanResult from "./result/FMatLbiFastScanResult"
import FMatLbiAsianResult from "./result/FMatLbiAsianResult"
import FMatMirrorResult from "./result/FMatMirrorResult"

export default () => {
  const { paperId } = useParams()

  let { lang } = useLanguageContext()
  if (!["en", "ko"].includes(lang)) lang = "en"

  return (
    <DinoContextProvider paperId={paperId!} lang={lang}>
      <Routes>
        <Route index element={<DinoEntryPage />} />
        <Route path=":pgmId/:contentId/intro" element={<Intro />} />
        <Route path=":pgmId/:contentId/:itemId" element={<QuestionnairePage />} />
        <Route path="FMAT_MIRROR/result" element={<FMatMirrorResult />} />
        <Route path="FMAT_LTM/result" element={<FMatQuadResult />} />
        <Route path="FMAT_TSI/result" element={<FMatTsiResult />} />
        <Route path="FMAT_SLP/result" element={<FMatQuadResult />} />
        <Route path="FMAT_LBI/result" element={<FMatQuadResult />} />
        <Route path="FMAT_LBI_ASIAN/result" element={<FMatLbiAsianResult />} />
        <Route path="FMAT_BSI360/result" element={<FMatBsi360Result />} />
        <Route path="FMAT_LBI_FS/result" element={<FMatLbiFastScanResult />} />
        <Route path="FMAT_HMI/result" element={<FMatHmiResult />} />
        <Route path="5LL_MC/result" element={<FiveLLResult />} />
        <Route path="5LL_UC/result" element={<FiveLLResult />} />
        <Route path="5LL_HS/result" element={<FiveLLResult />} />
        <Route path="5LL_LS/result" element={<FiveLLResult />} />
        <Route path="5LL_FA/result" element={<FiveLLResult />} />
        <Route path="5LL_CO/result" element={<FiveLLQuadResult />} />
        <Route path=":pgmId/report" element={<ResultReportPage />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </DinoContextProvider>
  )
}
